<template>
  <div class="">
    <div>
      <a-table
        :columns="columns"
        :data-source="displayStockCounts"
        :loading="tableLoading"
        :pagination="pagination"
        class="tableStyle"
      >
        <template slot="action" slot-scope="data">
          <a-dropdown>
            <a
              style="color: #98c14b"
              class="ant-dropdown-link"
              @click="(e) => e.preventDefault()"
            >
              <a-icon style="font-size: 25px" type="ellipsis" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="showMoreDetails(data)">More Details</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "DistroStockCounts",
  props: {
    counts: {
      type: Object,
      default: function () {
        return { data: [] };
      },
    },
  },
  data: () => ({
    tableLoading: false,
    selectedCount: {},
    pagination: {
      pageSize: 20,
    },
    columns: [
      {
        title: "Stock ID",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "Stock Type",
        dataIndex: "typeLabel",
        key: "typeLabel",
      },
      {
        title: "Quantity",
        dataIndex: "countLines",
        key: "countLines",
      },
      {
        title: "Created Date",
        dataIndex: "createdAt",
        key: "createdAt",
      },
      {
        title: "Action",
        key: "action",
        dataIndex: "action",
        scopedSlots: { customRender: "action" },
      },
    ],
    displayStockCounts: [],
    showUpdateModal: false
  }),
  watch: {
    counts: function(newStocks) { this.setTableData(newStocks)}
  },
  methods: {
   showMoreDetails(data) {
      // console.log(data)
      this.$store.commit('distroCenter/SET_SINGLE_STOCK_COUNT', data)
      this.$router.push({name: 'SingleStockCount', params:{stockId: data.id}}).catch(() => {});
    },
     setTableData(newStocks) {
      // console.log('new distros', newStocks);
      this.displayStockCounts = [...newStocks.data];
      this.displayStockCounts.forEach((stock) => {
        stock.createdAt = moment(stock.createdAt).format("DD-MMM-YYYY");
        stock.action = stock
        stock.countLines = stock.inventoryCountLines.length;
        stock.key = stock.id+stock.typeLabel
      });
    },
  },
  mounted() {
    this.setTableData(this.counts)
  }
};
</script>

<style scoped>
.requestActions{
    display: flex;
    justify-content:flex-end;
    margin-bottom: 20px;
}

.card-container {
  background: none;
  overflow: hidden;
  /* padding: 24px; */
}
.card-container > .ant-tabs-card > .ant-tabs-content {
  height: 120px;
  margin-top: -16px;
}

.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;

}

.card-container >>> .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
    height: 40px;
    color: #98c14b;
    background: #e5efe7;
    border-color: #e5efe7;
    border-bottom: 1px solid #98c14b;
}
.card-container >>> .ant-tabs-tab {
    height: 40px;
    margin: 0;
    width: 217px;
    margin-right: 2px;
    padding: 0 16px;
    line-height: 38px;
    background: #fafafa;
    border: 1px solid #e8e8e8;

}
.card-container >>> .ant-tabs-tab:hover {
    color: #98c14b;
    /* background: #e5efe7; */
}

.modalStyle >>> .ant-modal-header {
    border-bottom: none;
}

.modalStyle >>> .ant-modal-footer {
    border-top: none;
}
.modalStyle{
    display: flex;
    justify-content: center;
}

.card-container >>> .ant-badge-count {
    z-index: auto;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    color: #fff;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    white-space: nowrap;
    text-align: center;
    background: #98c14b;
    border-radius: 10px;
    box-shadow: 0 0 0 1px #fff;
}

 .spinner >>> .ant-spin-dot-item {
    background-color: #418a49;
}

.card-container > .ant-tabs-card > .ant-tabs-bar {
  border-color: #fff;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  border-color: #e5efe7;
  background: #e5efe7;
}

.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}

button:hover{
    color: #418a49;
    outline-color: #418a49;
    border-color: #418a49;
}
.tableStyle >>> .ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.tableStyle >>> .ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle >>> .ant-pagination-item-active a {
    color: #fff;
}
.tableStyle >>> .ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
  color: #fff;
}

.tableStyle>>>.ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
  background: #26A246;
  color: #fff;

}

.tableStyle>>>.ant-table-thead th {
  background: #fff;
  height: 63px;
}

.tableStyle>>>.ant-table-header {
  background: #fff !important;
}
</style>